import { useMemo } from 'react';
import { ITEMS } from '../../data/inventory.config';
import { giveItem } from '../../services/ItemGrantService';
import { closeInterface } from '../../services/InterfaceService';
import { logger } from '../../services/LoggerService';
import { useMenuNavigation } from '../../hooks/menu/useMenuNavigation';
import { Icon } from './Icon';
import { NineSliceFrame } from './NineSliceFrame';
import { KeyDisplay } from './KeyDisplay';
import './DevItemsScreen.scss';

export const DevItemsScreen = () => {
  const items = useMemo(
    () => Object.values(ITEMS).sort((a, b) => a.id.localeCompare(b.id)),
    [],
  );

  const { containerRef } = useMenuNavigation({
    onConfirm: (id) => {
      const def = ITEMS[id];
      if (!def) {
        return;
      }
      giveItem(id, 1);
      logger.info(`+1 ${def.label} (${id})`);
    },
    onCancel: () => closeInterface(),
    onPause: () => closeInterface(),
  });

  return (
    <div className="dev-items-overlay">
      <NineSliceFrame>
        <div className="dev-items-panel" ref={containerRef}>
          <div className="dev-items-header">
            <h2 className="dev-items-title">Donner un objet (dev)</h2>
            <span className="dev-items-count">{items.length} objets</span>
          </div>

          <div className="dev-items-list">
            {items.map((def, i) => (
              <div
                key={def.id}
                data-nav-row={i}
                data-nav-id={def.id}
                className="dev-items-row"
              >
                <Icon
                  sprite={def.sprite}
                  overlay={def.iconOverlay}
                  size={32}
                  className="dev-items-icon"
                />
                <span className="dev-items-name">{def.label}</span>
                <span className="dev-items-id">{def.id}</span>
              </div>
            ))}
          </div>

          <div className="dev-items-footer">
            <span className="dev-items-action">
              <KeyDisplay context="interface" action="CONFIRM" size="md" />
              Donner 1
            </span>
            <span className="dev-items-action">
              <KeyDisplay context="interface" action="CANCEL" size="md" />
              Fermer
            </span>
          </div>
        </div>
      </NineSliceFrame>
    </div>
  );
};
